'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactColor = require('react-color');

var _reactColor2 = _interopRequireDefault(_reactColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var outlineStyle = { outline: '8px auto #3b99fc' };

module.exports = function (_React$Component) {
  _inherits(ColorPickerUI, _React$Component);

  function ColorPickerUI(props) {
    _classCallCheck(this, ColorPickerUI);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ColorPickerUI).call(this, props));

    _this.intervals = [];
    _this.name = 'ColorPickerUI';
    _this.state = {
      isBlinking: false
    };
    return _this;
  }

  _createClass(ColorPickerUI, [{
    key: 'clearIntervals',
    value: function clearIntervals() {
      this.intervals.forEach(clearInterval);
      this.intervals = [];
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearIntervals();
    }
  }, {
    key: 'shouldStartBlinking',
    value: function shouldStartBlinking() {
      return this.props.blinkingComponent === this.name && this.intervals.length === 0;
    }
  }, {
    key: 'startBlinking',
    value: function startBlinking() {
      var _this2 = this;

      var blink = function blink() {
        return _this2.setState({ isBlinking: !_this2.state.isBlinking });
      };
      this.intervals.push(setInterval(blink, 500));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(color) {
      this.clearIntervals();
      this.props.changeBlinkingComponent('ColorPickerUI');
      this.setState({ isBlinking: false });
      this.props.handleChange(color);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.shouldStartBlinking()) this.startBlinking();
      var style = this.state.isBlinking ? outlineStyle : {};

      return _jsx('section', {
        className: 'm-colorpicker-container'
      }, void 0, _jsx('div', {
        className: 'row'
      }, void 0, _jsx('div', {}, void 0, _jsx('div', {
        className: 'm-colorpicker-title',
        style: style
      }, void 0, _jsx('img', {
        src: require('./assets/2.png'),
        'aria-hidden': true
      }), _jsx('span', {}, void 0, 'Then, pick a new color.')), _jsx('img', {
        src: require('./assets/arrow_2.png'),
        'aria-hidden': true,
        className: 'arrow-2'
      })), _jsx(_reactColor2['default'], {
        className: 'm-colorpicker',
        display: true,
        type: 'chrome',
        onChange: function onChange(color) {
          return _this3.handleChange(color);
        },
        color: this.props.selectedColor,
        positionCSS: { position: 'static' },
        style: { width: 10, outline: '8px auto #3b99fc' }
      })));
    }
  }]);

  return ColorPickerUI;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/color-picker-ui.jsx
 ** module id = 878
 ** module chunks = 0
 **/